<div class="volunteer-mentor-signups-dialog-part">

	<grid-content [setup]="setup" [namedSize]="'CustomHeight'" [customHeight]="customHeight()" [rows]="mentorSignups()"></grid-content>

</div>